import './HowItWorksContent.css';
export default function HowItWorksContent(){
  return (
    <section class="steps">
    <div class="step">
      <div class="text">
        <h2>1. Register & Login</h2>
        <p>Join the MotouraX community easily by verifying your mobile number using OTP. Your account lets you manage your rides, preferences, and connect with nearby garages.</p>
      </div>
      <img src="https://images.unsplash.com/photo-1502877338535-766e1452684a?auto=format&fit=crop&w=800&q=80" alt="Register & Login"/>
    </div>

    <div class="step reverse">
      <div class="text">
        <h2>2. Dashboard & Ride Tracking</h2>
        <p>Access your personalized dashboard to view recent rides, quick actions like SOS, and your favorite garages. Start and stop ride tracking with just one tap.</p>
      </div>
      <img src="https://images.unsplash.com/photo-1502877338535-766e1452684a?auto=format&fit=crop&w=800&q=80" alt="Dashboard & Tracking"/>
    </div>

    <div class="step">
      <div class="text">
        <h2>3. Find Nearby Garages</h2>
        <p>Our smart map interface shows all nearby garages with details such as operating hours, distance, and available services. Filter garages based on ratings, service type, or availability.</p>
      </div>
      <img src="https://images.unsplash.com/photo-1502877338535-766e1452684a?auto=format&fit=crop&w=800&q=80" alt="Nearby Garages"/>
    </div>

    <div class="step reverse">
      <div class="text">
        <h2>4. Garage Registration & Approval</h2>
        <p>Garage owners can register their business and services. Admin-approved garages appear in the rider’s map list, ensuring verified service providers for all users.</p>
      </div>
      <img src="https://images.unsplash.com/photo-1502877338535-766e1452684a?auto=format&fit=crop&w=800&q=80" alt="Garage Register"/>
    </div>

    <div class="step">
      <div class="text">
        <h2>5. Reviews, Ratings & Offline Access</h2>
        <p>Riders can share their experiences and rate garages. Plus, MotouraX supports offline functionality with preloaded garage data for emergencies in low-network zones.</p>
      </div>
      <img src="https://images.unsplash.com/photo-1502877338535-766e1452684a?auto=format&fit=crop&w=800&q=80" alt="Reviews and Offline"/>
    </div>
  </section>
  )
}